import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { setIsNoPeriodData } from '../../../redux/slices/meTicketData';

export default function TicketsNoData({ data }) {
  const isNoPeriodData = useSelector(
    (state) => state.meTicketData.isNoPeriodData
  );
  const dispatch = useDispatch();

  const { t } = useTranslation();

  useEffect(() => {
    dispatch(
      setIsNoPeriodData(!Object.keys(data.salesAndViewsDiagrams ?? {}).length)
    );
  }, [data, dispatch]);

  if (!isNoPeriodData) {
    return <></>;
  }

  return (
    <Col lg={12} xs={12}>
      <div
        className="px-3 py-2 col-12 rounded-1 fs-7"
        style={{ backgroundColor: '#FFFAED', color: '#E2B02F' }}
      >
        <i className="bi bi-info-circle pe-1"></i>
        <span>{t('ticketStatistic.noStatistics')}</span>
      </div>
    </Col>
  );
}
